import { render, staticRenderFns } from "./PpeComponent.vue?vue&type=template&id=6e088ea6&scoped=true&"
import script from "./PpeComponent.vue?vue&type=script&lang=js&"
export * from "./PpeComponent.vue?vue&type=script&lang=js&"
import style0 from "./PpeComponent.vue?vue&type=style&index=0&id=6e088ea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e088ea6",
  null
  
)

export default component.exports